<template>
  <div v-if="path && path.length">
    <div
      v-for="(entry, idx) in path"
      :key="idx"
      class="small mb-1"
    >
      <span
        v-if="entry.error"
        class="text-danger"
      >Error: {{ entry.error }}</span>
      <span
        v-else-if="entry.info === 'evaluating'"
        class="text-muted"
      >Evaluating {{ entry.rules_count }} matching rules</span>
      <span
        v-else-if="entry.info"
        class="text-muted"
      >{{ entry.reason || entry.info }}</span>
      <span
        v-else
        class="d-flex align-items-start gap-2"
      >
        <span
          class="badge"
          :class="statusClass(entry.result)"
        >{{ statusText(entry.result) }}</span>
        <span>
          <span class="text-muted">
            {{ entry.field }} = "{{ entry.computed_value ?? entry.record_value }}" {{ entry.operator }}
            {{ formatOperand(entry.operand) }}
          </span>
          <span
            v-if="entry.result === 'applied'"
            class="fw-medium ms-2"
          >→ ${{ formatMoney(entry.calculated_value) }} ({{ entry.measure }}, zone ${{ formatMoney(entry.zone_value) }})</span>
        </span>
      </span>
    </div>
  </div>
  <span
    v-else
    class="text-muted small"
  >No path data</span>
</template>

<script>
export default {
  props: { path: { type: Array, default: () => []}},
  methods: {
    statusClass(result) {
      if (result === 'applied') return 'bg-success';
      if (result === 'condition_not_met') return 'bg-danger';
      return 'bg-warning text-dark';
    },
    statusText(result) {
      if (result === 'applied') return 'APPLIED';
      if (result === 'condition_not_met') return 'NOT MET';
      return 'SKIPPED';
    },
    formatOperand(v) {
      if (Array.isArray(v)) {
        return `[${v.join(', ')}]`;
      }
      return String(v ?? '');
    },
    formatMoney(v) {
      return Number(v ?? 0).toFixed(2);
    },
  },
};
</script>
